var modules_efad2c92 = {"link":"ContactsBanner_module_link__9c6f3fec"};
import "../../../assets/fv_r23cg.css";

export { modules_efad2c92 as default };
//# sourceMappingURL=ContactsBanner.module.less.js.map
